import { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import useBillingCenters from "../../../states/billingCenter";

import { useAppContext } from "../../../context";
import centreFacturationService from "../../../services/centreFacturation/centreFacturationService";

export const BillingCenterSelector = ({
  selectedValue,
  onSelect,
  user,
  showLabel = false,
}) => {
  const { items: billingCenters, setItems: setBillingCenters } = useBillingCenters();
  const { isAuth } = useAppContext();

  const [page, setPage] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Réinitialise les données lors du changement d'utilisateur
   */
  useEffect(() => {
    setPage(1);
    setBillingCenters([]);
     fetchBillingCenters();
  }, [user]);

  /**
   * Récupère les centres de facturation
   */
  const fetchBillingCenters = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = {
        page,
        per_page: 30,
        type: isAuth?.spaceName,
        customer_id: user,
      };

      const { data } = await centreFacturationService.fetchCentreFacturationByUser(params);

      if (data.success) {
        console.log("data", data.data);
        const raw = data.data;
        const newOptions = raw.map((item) => ({
          label: item.billing_center_name,
          value: item.id,
        }));

      
        page===1 ? setBillingCenters(newOptions) : setBillingCenters( [...billingCenters, ...newOptions]);

        const lastPage = data.data?.last_page || data.last_page;
        if (lastPage && page < lastPage) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (err) {
      console.error("Erreur lors du chargement des centres de facturation :", err);
    } finally {
      setIsLoading(false);
    }
  }, [page, user, isAuth?.spaceName]);
  

  /**
   * Gère la sélection manuelle
   */
  const handleChange = (option) => {
    onSelect(option);
  };

  const value = billingCenters?.find((opt) => opt.value === selectedValue)

  return (
    <div>
      {showLabel && (
        <label htmlFor="billing-center-select" className="titre-detail">
          Centre de facturation
        </label>
      )}

      <Select
        inputId="billing-center-select"
        value={value}
        placeholder="CHOIX DU CENTRE*"
        className="text-base"
        options={billingCenters}
        onChange={handleChange}
        isLoading={isLoading}
        noOptionsMessage={() => "Pas de centre de facturation disponible"}
        loadingMessage={() => "Chargement..."}
      />
    </div>
  );
};
